import { useStore } from '@nanostores/react';
import { useEffect } from 'react';
import { accountStore } from '@/services/auth/store';
import { billing } from '@/services/billing';

/**
 * Adds the plan name to the FullStory user once billing loads, which is after FullStory's identify
 * call. The account id and plan slug go with it, and only billing loaded for the current account is
 * sent, so an in-app account switch never pairs one account's id with another account's plan.
 */
export function useFullStoryAccountPlan() {
  const account = useStore(accountStore);
  const billingAccountId = useStore(billing.initializedAccountId);
  const planName = useStore(billing.planNameShortened);
  const accountId = account?.id;
  const planSlug = account?.plan_slug ?? '';

  useEffect(() => {
    if (accountId == null || billingAccountId !== accountId || window.FS == null) {
      return;
    }

    window.FS.setUserVars({ accountId: String(accountId), planSlug, planName });
  }, [accountId, billingAccountId, planSlug, planName]);
}
